import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { Subject } from 'rxjs';

const apiURL = environment.apiURL;

@Injectable({
  providedIn: 'root'
})
export class DeliveriesService {

  deliveriesSub = new Subject<any>();

  constructor(private http: HttpClient) { }

  getDeliveries(data) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/deliveries/query/admin`, data);
  }

  setDeliveries(data) {
    this.deliveriesSub.next(data);
  }

  getDeliveriesSub() {
    return this.deliveriesSub.asObservable();
  }

  updateDeliveries(data) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/deliveries/admin`, data);
  }

  getNextDeliveryDates(data) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/deliveries`, data);
  }

  updateDeliveryDatesAsUser(data) {
    return this.http.put<{ success: boolean, data: any }>(`${apiURL}/deliveries/multi`, data);
  }

  downloadDocument(data) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/documents/delivery`, data);
  }

  updateSingleDeliveryDateAsAUser(data) {
    return this.http.put<{ success: boolean, data: any }>(`${apiURL}/deliveries`, data);
  }
}